import { useReviewsWizard } from '../ReviewsWizardProvider'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useReviewTemplates } from 'hooks/queries/reviewTemplates/useReviewTemplates'
import { collectResults, getTotalCountFromInfiniteQuery } from 'utils/query'
import Styles from './ReviewTemplates.module.scss'
import { EventId } from '../machineTypes'
import { Button } from 'components/Button'
import { ReviewTemplate } from 'types'
import { ReviewTemplatesSkeleton } from './ReviewTemplatesSkeleton'
import { useCallback } from 'react'
import { ReviewTemplateRow } from './ReviewTemplateRow'
import { ColdState } from './ColdState'

export const ReviewTemplates = () => {
  const { service } = useReviewsWizard()
  const workspaceId = useCurrentWorkspaceId()
  const reviewTemplatesQuery = useReviewTemplates({ workspaceId })
  const reviewTemplates = collectResults(reviewTemplatesQuery, (data) => data.review_templates)
  const totalTemplateCount = getTotalCountFromInfiniteQuery(reviewTemplatesQuery)

  const handleSelect = useCallback(
    (template: ReviewTemplate) => {
      service.send([{ type: EventId.SELECT_REVIEW_TEMPLATE, reviewTemplate: template }, { type: EventId.CONTINUE }])
    },
    [service],
  )

  const mostUsedReviewTemplates = reviewTemplates.slice(0, 3)

  if (reviewTemplatesQuery.isError) return null
  if (totalTemplateCount === 0 && !reviewTemplatesQuery.isLoading) return <ColdState />

  return (
    <div className={Styles.container}>
      <div>
        <div className={Styles.headers}>
          <div>Review templates</div>
          <div>Used</div>
        </div>
        {reviewTemplatesQuery.isLoading ? (
          <ReviewTemplatesSkeleton />
        ) : (
          <>
            {mostUsedReviewTemplates.map((template) => (
              <ReviewTemplateRow key={template.id} template={template} onSelect={handleSelect} />
            ))}

            {totalTemplateCount > 3 && (
              <Button
                onPress={() => service.send(EventId.VIEW_ALL_TEMPLATES)}
                variant="tertiary"
                size="lg"
                className={Styles.allTemplatesBtn}
              >
                See all {totalTemplateCount} templates
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  )
}
